import { createRouter, createWebHistory } from "vue-router";
import { ensureAuth } from "./auth";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./pages/LoginPage.vue"),
      meta: { public: true },
    },
    { path: "/", redirect: "/workbench" },
    { path: "/workbench", name: "workbench", component: () => import("./pages/WorkbenchPage.vue") },
    {
      path: "/candidates",
      name: "candidates",
      component: () => import("./pages/CandidatesPage.vue"),
    },
    {
      path: "/performance",
      name: "performance",
      component: () => import("./pages/PerformancePage.vue"),
    },
    {
      path: "/positions",
      name: "positions",
      component: () => import("./pages/PositionsPage.vue"),
    },
    {
      path: "/positions/:id",
      name: "position-detail",
      component: () => import("./pages/PositionDetailPage.vue"),
    },
    {
      path: "/candidates/:id",
      name: "candidate-detail",
      component: () => import("./pages/CandidateDetailPage.vue"),
    },
  ],
});

router.beforeEach(async (to) => {
  const user = await ensureAuth();
  if (!to.meta.public && !user) return { name: "login", query: { redirect: to.fullPath } };
  if (to.name === "login" && user) return { name: "workbench" };
  return true;
});
